import React from 'react';
import { AI_FAQ_ENTRIES, AI_SAMPLE_QUERIES, AI_CITATION } from 'seo/aiKnowledge';

export default function AiReferenceFaq() {
  return (
    <section
      id="ai-reference"
      className="ai-reference"
      aria-labelledby="ai-reference-heading"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <h2 id="ai-reference-heading" className="ai-reference__heading">
        คำถามที่พบบ่อย — เลขเด็ดจากฝัน
      </h2>
      <p className="ai-reference__cite-hint">
        {AI_CITATION.short} — อ้างอิงลิงก์:{' '}
        <a href={AI_CITATION.preferredLink()}>{AI_CITATION.preferredLink()}</a>
      </p>

      <dl className="ai-reference__list">
        {AI_FAQ_ENTRIES.map((entry) => (
          <div
            key={entry.id}
            className="ai-reference__item"
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
          >
            <dt className="ai-reference__question" itemProp="name">
              {entry.question}
            </dt>
            <dd
              className="ai-reference__answer"
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <span itemProp="text">{entry.answer}</span>
              {entry.url && (
                <a href={entry.url} className="ai-reference__link" itemProp="url">
                  ดูที่ Hotto →
                </a>
              )}
            </dd>
          </div>
        ))}
      </dl>

      <div className="ai-reference__samples" aria-label="ตัวอย่างคำถามที่ Hotto ตอบได้">
        <h3 className="ai-reference__subheading">ตัวอย่างคำถามที่ตอบได้</h3>
        <ul className="ai-reference__sample-list">
          {AI_SAMPLE_QUERIES.map((sample) => (
            <li key={sample.url}>
              <a href={sample.url}>{sample.query}</a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
